// src/pages/product/ViewProduct.jsx

import React from "react";
import { useParams,useNavigate } from "react-router-dom";

import {
  useGetSingleProductQuery,
} from "../../redux/services/productService/product.Services";

function ViewProduct() {
const navigate=useNavigate()
  const { id } = useParams();

  const {
    data,
    isLoading,
  } = useGetSingleProductQuery(id);

  const product = data?.data;

  if (isLoading) {
    return <h3>Loading...</h3>;
  }

  return (

    <div className="container py-4">


            <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              View Images
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <navigate to="/">
                  Home
                </navigate>
              </li>

              <li
                className="breadcrumb-item active"
                aria-current="page"
              >
                View Images
              </li>

            </ol>

          </nav>

        </div>
        <div className="page-title fw-semibold fs-18 mb-0">

          <button
            className="btn btn-primary me-2"
            onClick={() => navigate(-1)}
          >

            <span>
              <i className="fe fe-shopping-cart me-1"></i>
            </span>

            Product List

          </button>

        </div>

      </div>

      <div className="card shadow p-4">

        {/* TITLE */}
        <h2 className="mb-4">
          {product?.title}
        </h2>

        {/* THUMBNAIL */}
        <div className="mb-4">

       {product?.thumbnail_image ? (

  <img
    src={`http://localhost:5000/uploads/product/${product?.thumbnail_image}`}
    alt="thumbnail"
    width="250"
    className="rounded"
    style={{
      objectFit: "cover",
    }}
  />

) : (

  <p>No Thumbnail Image</p>

)}

        </div>

        {/* BASIC DETAILS */}
        <div className="row">

          <div className="col-md-6 mb-3">
            <strong>Category:</strong>
            <p>{product?.categoryName}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Sub Category:</strong>
            <p>{product?.subcatName}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>State:</strong>
            <p>{product?.stateName}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>City:</strong>
            <p>{product?.cityName}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Location:</strong>
            <p>{product?.location}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Price:</strong>
            <p>₹ {product?.price}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Guest:</strong>
            <p>{product?.guest}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Bedroom:</strong>
            <p>{product?.bedroom}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Bed:</strong>
            <p>{product?.bed}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Bathroom:</strong>
            <p>{product?.bathroom}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Rating:</strong>
            <p>{product?.rating}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Reviews:</strong>
            <p>{product?.noOfReviews}</p>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Status:</strong>

            <p>
              {product?.status}
            </p>

          </div>

        </div>

        {/* DESCRIPTION */}
        <div className="mb-4">

          <strong>Description:</strong>

          <p>
            {product?.description}
          </p>

        </div>

        {/* ADDRESS */}
        <div className="mb-4">

          <strong>Address:</strong>

          <p>
            {product?.address}
          </p>

        </div>

        {/* LAT LONG */}
        <div className="row">

          <div className="col-md-6 mb-3">

            <strong>Latitude:</strong>

            <p>
              {product?.latitude}
            </p>

          </div>

          <div className="col-md-6 mb-3">

            <strong>Longitude:</strong>

            <p>
              {product?.longitude}
            </p>

          </div>

        </div>

        {/* PRODUCT IMAGES */}
        {/* <div className="mt-4">

          <h4 className="mb-3">
            Product Images
          </h4>

          <div className="row">

            {product?.images?.map((img, index) => (

              <div
                key={index}
                className="col-md-3 mb-4"
              >

                <div className="card p-2">

                  <img
                   src={`${data?.imageBaseUrl}${img?.image}`}
                    alt="product"
                    height="180"
                    style={{
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />

                  <h6 className="mt-2 text-center">
                    {img?.title}
                  </h6>

                </div>

              </div>

            ))}

          </div>

        </div> */}

      </div>

    </div>
  );
}

export default ViewProduct;